import { FAQQuestion } from 'src/libs/faq-lib/faq.model'

export const generateFaqQuestion = (
    questionKey: string,
    showInTeaser: boolean = false
): FAQQuestion => ({
    questionKey,
    questionTranslationKey: `${questionKey}-question-key`,
    answerTranslationKey: `${questionKey}-answer-key`,
    showInTeaser: showInTeaser,
})
